import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Subheading from "../../../../../components/theme/text/Subheading";
import Text from "../../../../../components/theme/text/Text";
import { tokens } from "../../../../../theme";

import TabView3 from "../../../../../components/theme/TabView3/TabView3";
import { useGetSettingsQuery } from "../../../../../newapi/global/generalApiSlice";
import { selectUser } from "../../../../../newapi/user/authentication/authSlice";
import { getSettingsWarehouseSetupCore } from "./settingsWarehouseSetupCore";
import SetupPanelBasicSetup from "./views/General";
import SetupPanelImport from "./views/Import";
import SetupPanelFacturatie from "./views/Facturatie";

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: false,
    hide:true,
    

};

const Core = (props) => {
    const { t } = useTranslation();

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // The facturatie tab is superadmin (sha) only
    const user = useSelector(selectUser);
    const config = getSettingsWarehouseSetupCore(!!user?.sha);

    const { data: incData} = useGetSettingsQuery("core");
    const [data, setData] = useState();
    
    useEffect(() => {
        setData(incData);
    },[incData]);

    useEffect(() => {
        props.replaceView({
            ...props.config,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    

    return (
        <Box
            sx={{
                padding:"0px 32px",
                paddingTop:"32px",
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            <Box
            sx={{
                //padding:"0px 32px",
                marginBottom:"32px",
                //height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                    display:'none'
                }}}
                >
                <Subheading>{t("core_settings_title")}</Subheading>
                <Text light>{t("core_settings_subtitle")}</Text>
            </Box>

            <TabView3
                 tabConfig={config}
                viewType="bodytabs"
                sx={{
                    position:"relative",
                    zIndex:2,
                    display: "flex",
                    flex:1,
                    height:1,
                    "@media screen and (max-width: 47.9375em)" : {
                        "&:before" : {
                            content: "''",
                            display:"block",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            // transition:"250ms"
                        },
        
                        "&:after" : {
                            content: "''",
                            display:"block",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            // transition:"250ms"
                        },
                    }
                  
                }}
                tabClasses={"btn-body-tab"}
            >
               <>
                    <SetupPanelBasicSetup config={config.general}  />
                    <SetupPanelImport config={config.import}  />
                    {config.facturatie && <SetupPanelFacturatie config={config.facturatie}  />}
                </>
            </TabView3>
        </Box>
    )
}

export default Core;